module.exports = __webpack_public_path__ + "static/img/1046.68f586b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1046.jpg
// module id = 228
// module chunks = 0